<template>
  <div class="rule-container" v-wechat-title="$route.meta.title= pageTitle">
    <barTitle :curUrlKey="curUrlKey" :titleText="titleText" :username="username" />
    <div class="rule-container">
      <div
        class="content"
        v-html="ruleInfo.activity_text"
        v-if="ruleInfo.activity_text"
      >
        {{ ruleInfo.activity_text }}
      </div>
      <div class="not-list" v-else>
        <div class="not-list-content">
          <img
            class="not-list-img"
            src="http://aimg8.dlssyht.net.cn/xcx_pack/images/nolist.jpg"
            alt=""
          />
          <p class="not-list-text">抱歉暂无规则信息~</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import barTitle from "./components/Title";
export default {
  name: "bargainRule",
  data() {
    return {
      curUrlKey: "rule",
      pageTitle: "微砍价",
      titleText: "砍价规则", // 标题文字
      isIndexList: false, // 是否为列表页
      ruleInfo: {},
      username: "", //	网站用户名
      act_id: "", //活动ID
      baseUrl: "",
      port: "",
      domain: ""
    };
  },
  components: {
    barTitle
  },
  created() {
    var params = this.$route.query;
    this.username = params.username;
    this.act_id = params.act_id;
    if (document.location.protocol == "https:") {
      this.port = ":12702";
    } else {
      this.port = ":12701";
    }
    // this.domain = "m.evyun.cn";
    this.domain = document.domain;
    this.baseUrl = this.domain + this.port;
  },
  mounted() {
    const ruleParams = {
      username: this.username,
      act_id: this.act_id
    };
    this.getRuleInfo(ruleParams);
  },
  methods: {
    // 获取[设置]接口
    getRuleInfo(axparams) {
      this.$axios
        .get(`//${this.baseUrl}/Frontend/Bargain/bargainInfoText`, {
          params: axparams
        })
        .then(this.getRuleInfoSucc);
    },
    getRuleInfoSucc(res) {
      res = res.data;
      if (res.data && res.code == 200) {
        this.ruleInfo = res.data.act_info;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.rule-container {
  min-width: 3.2rem;
  max-width: 7.68rem;
  margin: 0 auto;
  min-height: 100vh;
  background: #fff;
}
.title {
  padding: 0.2rem 0 0.66rem;
  font-size: 0.38rem;
  line-height: 0.38rem;
  text-align: center;
}
.content {
  border-top: 1px solid #ededed;
  padding: 0.3rem;
  overflow: hidden;
}
.content /deep/ img {
  max-width: 100%;
}
.not-list-content {
  position: absolute;
  top: 20vh;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  font-size: 0.28rem;
  color: #999;
  .not-list-img {
    display: block;
    width: 3rem;
    height: 3rem;
    margin: 0 auto;
  }
  .not-list-p {
    margin-top: 0.2rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Bargain/Rule.vue